/*
  Ribelli Sichtschutz-Rechner (04.10.2026) — gehört zu sections/ribelli-sichtschutz-rechner.liquid.
  Kein Build, keine Bibliothek. Wird mit defer geladen.

  Aufbau
    1. REGELN — reine Funktionen ohne DOM. Node-Tests: shopify-app/rechner_test/rechner.test.mjs
       (dort per require geladen; module.exports liefert genau diesen Block).
    2. OBERFLÄCHE — baut den Rechner aus den beiden JSON-Inseln der Sektion:
         [data-rbsr-daten]   {"produkte":[{handle,title,url,familie,typ,farbe,farbe_hex,bild,
                               varianten:[{id,laenge_m,hoehe_cm,stueck,laenge_txt,hoehe_txt,price,available}]}]}
         [data-rbsr-config]  {modus, maxUeberstand, start, leisteAnbieten, versandUrl, rechnerUrl, vorwahl, texte}

  Fachregeln (Produkttexte, Stand 04.10.2026)
    - Mattenhöhe = größte vorhandene Höhe <= Geländerhöhe + max. Überstand (Standard 10 cm).
    - Länge auf volle Meter aufrunden; bis 10 m eine Variante, darüber die Kombination mit den wenigsten
      Artikeln, dann dem niedrigsten Gesamtpreis — nur aus lieferbaren Varianten.
    - Ab 6 m kommt eine Variante als zwei Matten (6 = 3+3, 7 = 3+4, 8 = 4+4, 9 = 4+5, 10 = 5+5).
    - Abschlussleiste: je angefangenem Meter ein Stück à 100 cm; mehr als 10 Stück = mehrere Artikel.
      Nie vorausgewählt (§ 312a Abs. 3 BGB).
*/
(function (global) {
  'use strict';

  /* ==================== REGELN BEGINN ==================== */
  var R = {};
  var EPS = 1e-9;

  /** Erste Zahl aus einem Text: "3 Meter" → 3, "80 cm" → 80, "3 x 100cm" → 3, "2,5" → 2.5. NaN, wenn keine. */
  R.zahlAus = function (s) {
    if (typeof s === 'number') return isFinite(s) ? s : NaN;
    if (s === null || s === undefined) return NaN;
    var m = String(s).replace(/ /g, ' ').match(/-?\d+(?:[.,]\d+)?/);
    return m ? parseFloat(m[0].replace(',', '.')) : NaN;
  };

  /** Deutsche Zahl: 1234.5 → "1.234,50" (stellen = 2) */
  R.formatZahl = function (n, stellen) {
    if (stellen === undefined) stellen = 2;
    var neg = n < 0;
    var t = Math.abs(n).toFixed(stellen).split('.');
    var ganz = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (neg ? '−' : '') + ganz + (t[1] ? ',' + t[1] : '');
  };

  /** 1.5 → "1,5 m", 3 → "3 m" (geschütztes Leerzeichen) */
  R.formatMeter = function (m) {
    var r = Math.round(m * 10) / 10;
    return (Math.abs(r % 1) < EPS ? String(Math.round(r)) : R.formatZahl(r, 1)) + ' m';
  };

  R.formatCm = function (cm) { return Math.round(cm) + ' cm'; };

  /** Cent → "34,99 €" */
  R.formatEuro = function (cent) { return R.formatZahl((cent || 0) / 100, 2) + ' €'; };

  /** In [min, max] halten und auf das Raster runden */
  R.begrenzen = function (x, min, max, schritt) {
    if (!isFinite(x)) return min;
    var v = Math.min(max, Math.max(min, x));
    if (schritt) v = Math.round(v / schritt) * schritt;
    return Math.round(v * 1000) / 1000;
  };

  /** Auf volle Meter aufrunden, mindestens 1 */
  R.laengeAufrunden = function (m) {
    if (!isFinite(m) || m <= 0) return 1;
    return Math.max(1, Math.ceil(m - EPS));
  };

  /** Lieferaufteilung einer Variante in einzelne Matten */
  R.mattenAufteilung = function (laenge) {
    if (laenge >= 6) return [Math.floor(laenge / 2), Math.ceil(laenge / 2)];
    return [laenge];
  };

  /** Daten aus der Liquid-Insel säubern: Zahlen sicherstellen, notfalls aus dem Optionstext lesen */
  R.normalisiere = function (daten) {
    var liste = (daten && daten.produkte) || [];
    return liste.filter(function (p) { return p && p.varianten && p.varianten.length; }).map(function (p) {
      return {
        handle: p.handle, title: p.title, url: p.url, bild: p.bild || null,
        familie: p.familie || 'matte', typ: p.typ || 'ohne', farbe: p.farbe || '', farbe_hex: p.farbe_hex || null,
        varianten: p.varianten.map(function (v) {
          var l = +v.laenge_m, h = +v.hoehe_cm, s = +v.stueck;
          if (!(l > 0)) l = R.zahlAus(v.laenge_txt);
          if (!(h > 0)) h = R.zahlAus(v.hoehe_txt);
          if (!(s > 0)) s = R.zahlAus(v.laenge_txt);
          return { id: v.id, titel: v.titel || '', laenge_m: l > 0 ? l : null, hoehe_cm: h > 0 ? h : null,
                   stueck: s > 0 ? s : null, price: Math.round(+v.price || 0), available: v.available === true };
        })
      };
    });
  };

  R.finde = function (produkte, familie, farbe, typ) {
    for (var i = 0; i < produkte.length; i++) {
      var p = produkte[i];
      if (p.familie === familie && p.farbe === farbe && (typ === undefined || p.typ === typ)) return p;
    }
    return null;
  };

  R.hoehenVon = function (produkt) {
    var s = {};
    (produkt ? produkt.varianten : []).forEach(function (v) { if (v.hoehe_cm) s[v.hoehe_cm] = 1; });
    return Object.keys(s).map(Number).sort(function (a, b) { return a - b; });
  };

  /**
   * Mattenhöhe wählen.
   * status: 'ok' | 'zu_niedrig' (selbst die kleinste Matte stünde mehr als maxUeberstand über)
   *         | 'zu_hoch' (Geländer höher als die höchste Matte)
   * ueberstand: Matte minus Geländer in cm (negativ = endet unter der Oberkante)
   */
  R.waehleHoehe = function (hoehen, stuetze, maxUeberstand) {
    var h = (hoehen || []).slice().sort(function (a, b) { return a - b; });
    if (!h.length) return null;
    var grenze = stuetze + (maxUeberstand || 0);
    var passend = h.filter(function (x) { return x <= grenze + EPS; });
    if (passend.length) {
      var w = passend[passend.length - 1];
      return { hoehe: w, status: stuetze > h[h.length - 1] ? 'zu_hoch' : 'ok', ueberstand: w - stuetze };
    }
    return { hoehe: h[0], status: 'zu_niedrig', ueberstand: h[0] - stuetze };
  };

  /** Angebote einer Matte in einer Höhe: [{laenge, preis, id, lieferbar}] */
  R.angeboteMatte = function (produkt, hoehe, nurLieferbar) {
    if (!produkt) return [];
    return produkt.varianten.filter(function (v) {
      return v.hoehe_cm === hoehe && v.laenge_m > 0 && (!nurLieferbar || v.available);
    }).map(function (v) { return { laenge: v.laenge_m, preis: v.price, id: v.id, lieferbar: v.available }; });
  };

  /** Angebote der Abschlussleiste: laenge = Stückzahl à 100 cm */
  R.angeboteLeiste = function (produkt, nurLieferbar) {
    if (!produkt) return [];
    return produkt.varianten.filter(function (v) {
      return v.stueck > 0 && (!nurLieferbar || v.available);
    }).map(function (v) { return { laenge: v.stueck, preis: v.price, id: v.id, lieferbar: v.available }; });
  };

  function besser(a, b) {
    if (!b) return true;
    if (a.n !== b.n) return a.n < b.n;
    if (a.p !== b.p) return a.p < b.p;
    for (var i = 0; i < a.teile.length && i < b.teile.length; i++) {
      if (a.teile[i].laenge !== b.teile[i].laenge) return a.teile[i].laenge > b.teile[i].laenge;
    }
    return false;
  }

  /**
   * Kombination für eine Ziellänge (ganze Einheiten).
   * Genau die Ziellänge mit den wenigsten Artikeln, dann dem niedrigsten Preis (Gleichstand: längere Teile zuerst).
   * Geht es nicht genau, die kleinste größere Gesamtlänge (exakt = false, zum Kürzen).
   * → { teile:[{laenge,preis,id,lieferbar}] (absteigend), summe, preis, stueck, exakt } | null
   */
  R.kombiniere = function (ziel, angebote) {
    ziel = Math.max(1, Math.round(ziel));
    var proLaenge = {};
    (angebote || []).forEach(function (a) {
      if (!a || !(a.laenge > 0) || Math.round(a.laenge) !== a.laenge) return;
      var alt = proLaenge[a.laenge];
      if (!alt || a.preis < alt.preis) proLaenge[a.laenge] = a;
    });
    var liste = Object.keys(proLaenge).map(function (k) { return proLaenge[k]; });
    if (!liste.length) return null;
    var maxL = Math.max.apply(null, liste.map(function (a) { return a.laenge; }));
    var grenze = ziel + maxL;
    var best = new Array(grenze + 1);
    best[0] = { n: 0, p: 0, teile: [] };
    for (var t = 1; t <= grenze; t++) {
      for (var i = 0; i < liste.length; i++) {
        var a = liste[i], vor = best[t - a.laenge];
        if (t < a.laenge || !vor) continue;
        var teile = vor.teile.concat([a]).sort(function (x, y) { return y.laenge - x.laenge; });
        var k = { n: vor.n + 1, p: vor.p + a.preis, teile: teile };
        if (besser(k, best[t])) best[t] = k;
      }
    }
    for (var s = ziel; s <= grenze; s++) {
      if (best[s]) return { teile: best[s].teile, summe: s, preis: best[s].p, stueck: best[s].n, exakt: s === ziel };
    }
    return null;
  };

  /** Teile einer Kombination zu Warenkorb-Positionen zusammenfassen: [{id, laenge, preis, anzahl, lieferbar}] */
  R.positionen = function (kombi) {
    if (!kombi) return [];
    var map = {}, reihe = [];
    kombi.teile.forEach(function (t) {
      if (!map[t.id]) { map[t.id] = { id: t.id, laenge: t.laenge, preis: t.preis, anzahl: 0, lieferbar: t.lieferbar !== false }; reihe.push(map[t.id]); }
      map[t.id].anzahl++;
    });
    return reihe;
  };

  /** Einzelne Matten in Lieferreihenfolge, z. B. 10 + 4 → [5, 5, 4] */
  R.mattenListe = function (kombi) {
    var out = [];
    (kombi ? kombi.teile : []).forEach(function (t) { out = out.concat(R.mattenAufteilung(t.laenge)); });
    return out;
  };

  /**
   * Gesamtergebnis. eingabe: {laenge (m, wie eingegeben), stuetze (cm), farbe, typ, ueberstandOk, alternative}
   * opts: {maxUeberstand, leiste (bool, anbieten)}
   */
  R.berechne = function (e, produkte, opts) {
    opts = opts || {};
    var maxU = opts.maxUeberstand === undefined ? 10 : opts.maxUeberstand;
    var laenge = e.laenge > 0 ? e.laenge : 1;
    var ziel = R.laengeAufrunden(laenge);
    var res = { eingabe: e, laenge: laenge, ziel: ziel, maxUeberstand: maxU, fehler: null, alternativen: [],
                aktiv: null, leiste: null, lieferbar: false, gesperrt: false };
    var prod = R.finde(produkte, 'matte', e.farbe, e.typ);
    res.produkt = prod;
    if (!prod) { res.fehler = 'kein_produkt'; return res; }
    var hw = R.waehleHoehe(R.hoehenVon(prod), e.stuetze, maxU);
    res.hoehe = hw;
    if (!hw) { res.fehler = 'keine_variante'; return res; }
    res.gesperrt = hw.status === 'zu_niedrig' && !e.ueberstandOk;

    var wunsch = R.kombiniere(ziel, R.angeboteMatte(prod, hw.hoehe, false));
    res.wunsch = wunsch;
    if (!wunsch) { res.fehler = 'keine_variante'; return res; }
    res.lieferbar = wunsch.teile.every(function (t) { return t.lieferbar; });

    if (res.lieferbar) {
      res.aktiv = { art: 'wunsch', produkt: prod, kombi: wunsch, hoehe: hw.hoehe };
    } else {
      var gleich = R.kombiniere(ziel, R.angeboteMatte(prod, hw.hoehe, true));
      if (gleich) res.alternativen.push({ art: gleich.exakt ? 'aufteilung' : 'laenger', produkt: prod, kombi: gleich, hoehe: hw.hoehe });
      produkte.forEach(function (p) {
        if (p.familie !== 'matte' || p.farbe !== e.farbe || p.typ === e.typ) return;
        var hw2 = R.waehleHoehe(R.hoehenVon(p), e.stuetze, maxU);
        if (!hw2) return;
        var k = R.kombiniere(ziel, R.angeboteMatte(p, hw2.hoehe, true));
        if (k) res.alternativen.push({ art: 'typ', produkt: p, kombi: k, hoehe: hw2.hoehe });
      });
      var wahl = e.alternative;
      if (wahl !== null && wahl !== undefined && res.alternativen[wahl] && res.alternativen[wahl].art !== 'typ') {
        res.aktiv = res.alternativen[wahl];
      }
    }

    var basis = res.aktiv ? res.aktiv.kombi : wunsch;
    res.matten = R.mattenListe(basis);
    res.ueberlaenge = Math.max(0, basis.summe - laenge);

    if (opts.leiste !== false) {
      var lp = R.finde(produkte, 'leiste', e.farbe);
      if (lp) {
        var stueck = R.laengeAufrunden(laenge);
        res.leiste = { produkt: lp, stueck: stueck, kombi: R.kombiniere(stueck, R.angeboteLeiste(lp, true)) };
      }
    }
    return res;
  };

  /** Preis der aktiven Matten, optional mit Leiste (Cent) */
  R.summe = function (res, mitLeiste) {
    if (!res || !res.aktiv) return 0;
    var s = res.aktiv.kombi.preis;
    if (mitLeiste && res.leiste && res.leiste.kombi) s += res.leiste.kombi.preis;
    return s;
  };

  /** Positionen für /cart/add.js */
  R.warenkorbPosten = function (res, mitLeiste, quelle) {
    if (!res || !res.aktiv || res.gesperrt) return [];
    var props = { _quelle: quelle || 'sichtschutz-rechner' };
    var teile = R.positionen(res.aktiv.kombi);
    if (mitLeiste && res.leiste && res.leiste.kombi) teile = teile.concat(R.positionen(res.leiste.kombi));
    return teile.map(function (t) { return { id: t.id, quantity: t.anzahl, properties: props }; });
  };

  /** "3 m + 4 m" bzw. "2 × 5 m + 4 m" */
  R.teileText = function (laengen) {
    var reihe = [], zahl = {};
    laengen.forEach(function (l) { if (!zahl[l]) { zahl[l] = 0; reihe.push(l); } zahl[l]++; });
    return reihe.map(function (l) { return (zahl[l] > 1 ? zahl[l] + ' × ' : '') + R.formatMeter(l); }).join(' + ');
  };
  /* ==================== REGELN ENDE ==================== */

  if (typeof module === 'object' && module && module.exports) { module.exports = R; return; }
  global.RibelliSichtschutz = R;
  if (typeof document === 'undefined') return;

  /* ==================== OBERFLÄCHE ==================== */

  /*
    Texte: Standardwerte. Die Sektion überschreibt die redaktionellen (Einstellungen → config.texte);
    {x} wird ersetzt. Ton: Sie-Form, sachlich, keine Ausrufezeichen, keine Superlative.
  */
  var TEXTE = {
    ort: 'Montageort', orte: { balkon: 'Balkon', zaun: 'Zaun', terrasse: 'Terrasse' },
    stuetzeName: { balkon: 'Geländer', zaun: 'Zaun', terrasse: 'Geländer' },
    laenge: 'Länge der Fläche', laengeHilfe: 'Von Pfosten zu Pfosten gemessen',
    hoehe: 'Höhe von Geländer oder Zaun', hoeheHilfe: 'Vom Boden bis zur Oberkante',
    laengeFehler: 'Bitte eine Länge zwischen {min} und {max} eingeben.',
    hoeheFehler: 'Bitte eine Höhe zwischen {min} und {max} eingeben.',
    farbe: 'Farbe', ausfuehrung: 'Ausführung',
    typ_ohne_titel: 'Standard', typ_ohne_text: 'Rohre ohne Innensteg',
    typ_steg_titel: 'Mit Steg – extra stabil', typ_steg_text: 'Ein Steg in jedem Rohr macht die Rohre deutlich steifer',
    preisDiff: '{x} mehr als Standard', preisGleich: 'Gleicher Preis wie Standard', preisWeniger: '{x} weniger als Standard',
    nichtLieferbarKurz: 'In dieser Größe zurzeit nicht lieferbar',
    ergebnisTitel: 'Ihre Sichtschutzmatte',
    hoeheOk: 'Mattenhöhe {h} – ragt {u} über die Oberkante.',
    hoeheBuendig: 'Mattenhöhe {h} – schließt bündig mit der Oberkante ab.',
    hoeheUnter: 'Mattenhöhe {h} – endet {u} unter der Oberkante.',
    hoeheZuHoch: 'Die höchste Matte ist {h} hoch. Sie deckt {h} Ihrer {s} ab.',
    hoeheZuNiedrig: 'Ihr {stuetze} ist niedriger, als es die kleinste Matte erlaubt: {h} stünde {u} über. Empfohlen sind höchstens {max} über der Halterung.',
    hoeheTrotzdem: '{h} trotzdem verwenden',
    lieferung1: 'Sie erhalten 1 Matte.',
    lieferungN: 'Sie erhalten {n} Matten: {teile}.',
    kuerzen: 'Die Matte ist {x} länger als Ihre Fläche und lässt sich kürzen.',
    kuerzenLink: 'Anleitung in der Produktbeschreibung',
    lieferbar: 'Lieferbar', nichtLieferbar: 'Zurzeit nicht lieferbar',
    nichtLieferbarText: '{groesse} ist in dieser Ausführung zurzeit nicht lieferbar.',
    bisLink: 'Benachrichtigung auf der Produktseite einrichten',
    alternativenTitel: 'Lieferbare Alternativen',
    alt_aufteilung: 'Gleiche Matte, aufgeteilt: {teile}',
    alt_laenger: 'Gleiche Matte, {x} lang (zum Kürzen)',
    alt_typ: '{typ}, {x}',
    altGewaehlt: 'Alternative gewählt',
    stueckPos: '{n} × {l} × {h}',
    je: 'je {x}',
    leiste: 'Passende Abschlussleiste dazu: {n} × 100 cm, Farbe {farbe}',
    leisteText: 'Schützt die Rohre oben vor Schmutz und Wasser.',
    leisteAufteilung: 'Geliefert als {teile} Stück',
    leisteNicht: 'Die passende Abschlussleiste ist zurzeit nicht lieferbar.',
    gesamt: 'Gesamt', steuer: 'inkl. MwSt., zzgl.', versand: 'Versand',
    kaufen: 'In den Warenkorb', laedt: 'Wird hinzugefügt …', hinzugefuegt: 'Zum Warenkorb hinzugefügt.',
    grundGesperrt: 'Bitte bestätigen Sie zuerst die Mattenhöhe.',
    grundAlternative: 'Bitte wählen Sie oben eine lieferbare Alternative.',
    grundKeine: 'Für diese Auswahl gibt es zurzeit keine lieferbare Matte.',
    fehlerNetz: 'Der Warenkorb ist gerade nicht erreichbar. Bitte versuchen Sie es noch einmal.',
    zumProdukt: 'Zum Produkt',
    zumErgebnis: 'Details',
    zumRechner: 'Zum Sichtschutz-Rechner',
    szene: 'Vorschau: {l} Sichtschutzmatte, {h} hoch, an einem {stuetze} von {s} Höhe.',
    kurz: '{l} × {h}',
    farben: { anthrazit: 'Anthrazit', bambus: 'Bambus', braun: 'Braun' }
  };

  /* Rohrfarben, abgenommen vom Look der Produktbilder: Grundton, Lichtkante, Schattenkante */
  var FARBEN = {
    anthrazit: ['#43474c', '#5f646a', '#2b2d31'],
    bambus: ['#cbb68a', '#e0d0a9', '#a48f62'],
    braun: ['#6d4a32', '#8a6447', '#4c3222']
  };

  var NS = 'http://www.w3.org/2000/svg';
  var reduziert = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)');

  function fmt(t, w) {
    return String(t).replace(/\{(\w+)\}/g, function (_, k) { return w && w[k] !== undefined ? w[k] : ''; });
  }
  function el(tag, attrs, kinder) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (attrs[k] === null || attrs[k] === undefined || attrs[k] === false) continue;
      if (k === 'text') e.textContent = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else e.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    }
    (kinder || []).forEach(function (c) { if (c) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }
  function sv(tag, attrs) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs || {}) e.setAttribute(k, attrs[k]);
    return e;
  }
  function setze(e, k, v) { if (e.getAttribute(k) !== String(v)) e.setAttribute(k, v); }
  function text(e, t) { if (e.textContent !== t) e.textContent = t; }
  function hexMisch(hex, ziel, anteil) {
    var a = parseInt(hex.slice(1), 16), b = parseInt(ziel.slice(1), 16);
    var r = Math.round(((a >> 16) & 255) * (1 - anteil) + ((b >> 16) & 255) * anteil);
    var g = Math.round(((a >> 8) & 255) * (1 - anteil) + ((b >> 8) & 255) * anteil);
    var bl = Math.round((a & 255) * (1 - anteil) + (b & 255) * anteil);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + bl).toString(16).slice(1);
  }
  function farbTon(key, produkt) {
    if (FARBEN[key]) return FARBEN[key];
    var hex = (produkt && produkt.farbe_hex) || '#888888';
    return [hex, hexMisch(hex, '#ffffff', 0.22), hexMisch(hex, '#000000', 0.3)];
  }
  function icon(name) {
    var pfade = {
      ok: 'M5 12.5l4.2 4.2L19 7',
      info: 'M12 8v.01M11 12h1v5h1M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18z',
      warn: 'M12 9v4m0 3.5v.01M10.3 3.9L2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z',
      schere: 'M6 9a3 3 0 1 0 0-6a3 3 0 0 0 0 6zm0 12a3 3 0 1 0 0-6a3 3 0 0 0 0 6zM8.1 8.1L20 20M8.1 15.9L20 4',
      pfeil: 'M5 12h14M13 6l6 6-6 6'
    };
    var s = sv('svg', { viewBox: '0 0 24 24', width: '20', height: '20', fill: 'none', stroke: 'currentColor',
      'stroke-width': '1.8', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false', 'class': 'rbsr__icon' });
    s.appendChild(sv('path', { d: pfade[name] }));
    return s;
  }

  /* Kubische Bézierkurve wie in CSS: cubic-bezier(0.23, 1, 0.32, 1) — starkes ease-out */
  function bezier(x1, y1, x2, y2) {
    function a(p1, p2) { return 1 - 3 * p2 + 3 * p1; }
    function b(p1, p2) { return 3 * p2 - 6 * p1; }
    function c(p1) { return 3 * p1; }
    function kurve(t, p1, p2) { return ((a(p1, p2) * t + b(p1, p2)) * t + c(p1)) * t; }
    function steig(t, p1, p2) { return 3 * a(p1, p2) * t * t + 2 * b(p1, p2) * t + c(p1); }
    return function (x) {
      if (x <= 0) return 0; if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 8; i++) {
        var d = steig(t, x1, x2); if (Math.abs(d) < 1e-6) break;
        t -= (kurve(t, x1, x2) - x) / d;
      }
      return kurve(Math.min(1, Math.max(0, t)), y1, y2);
    };
  }
  var EASE = bezier(0.23, 1, 0.32, 1);

  /* ---------- Szene: Geländer/Zaun mit Matte, maßstäblich ---------- */
  function Szene(wurzel, uid) {
    this.uid = uid;
    this.box = el('div', { 'class': 'rbsr__szene' });
    var svg = this.svg = sv('svg', { 'class': 'rbsr__svg', role: 'img', focusable: 'false' });
    var defs = sv('defs');
    var rohr = this.rohr = sv('pattern', { id: uid + '-rohr', patternUnits: 'userSpaceOnUse', width: '5', height: '40' });
    rohr.appendChild(sv('rect', { width: '5', height: '40', 'class': 'rbsr-r-grund' }));
    rohr.appendChild(sv('rect', { x: '0.4', width: '1.2', height: '40', 'class': 'rbsr-r-licht' }));
    rohr.appendChild(sv('rect', { x: '4.2', width: '0.8', height: '40', 'class': 'rbsr-r-schatten' }));
    this.steg = sv('rect', { x: '2.3', width: '0.5', height: '40', 'class': 'rbsr-r-steg' });
    rohr.appendChild(this.steg);
    var verlauf = sv('linearGradient', { id: uid + '-licht', x1: '0', y1: '0', x2: '0', y2: '1' });
    verlauf.appendChild(sv('stop', { offset: '0', 'stop-color': '#fff', 'stop-opacity': '0.14' }));
    verlauf.appendChild(sv('stop', { offset: '0.55', 'stop-color': '#fff', 'stop-opacity': '0' }));
    verlauf.appendChild(sv('stop', { offset: '1', 'stop-color': '#000', 'stop-opacity': '0.16' }));
    var stab = this.stab = sv('pattern', { id: uid + '-stab', patternUnits: 'userSpaceOnUse', width: '8', height: '10' });
    stab.appendChild(sv('rect', { width: '1.6', height: '10', 'class': 'rbsr-s-stab' }));
    var masche = this.masche = sv('pattern', { id: uid + '-masche', patternUnits: 'userSpaceOnUse', width: '6', height: '24' });
    this.mascheV = sv('rect', { width: '1', height: '24', 'class': 'rbsr-s-stab' });
    this.mascheH = sv('rect', { width: '6', height: '1.2', y: '0', 'class': 'rbsr-s-stab' });
    masche.appendChild(this.mascheV); masche.appendChild(this.mascheH);
    var diele = this.diele = sv('pattern', { id: uid + '-diele', patternUnits: 'userSpaceOnUse', width: '30', height: '10' });
    diele.appendChild(sv('rect', { width: '1', height: '10', 'class': 'rbsr-s-fuge' }));
    [rohr, verlauf, stab, masche, diele].forEach(function (d) { defs.appendChild(d); });
    svg.appendChild(defs);

    var g = function (cls) { var e = sv('g', { 'class': cls }); svg.appendChild(e); return e; };
    var gb = g('rbsr-g-boden'), gm = g('rbsr-g-mensch'), gw = g('rbsr-g-matte'), gs = g('rbsr-g-stuetze'), gx = g('rbsr-g-mass');
    this.boden = sv('path', { 'class': 'rbsr-boden' }); gb.appendChild(this.boden);
    this.platte = sv('rect', { 'class': 'rbsr-platte' }); gb.appendChild(this.platte);
    this.platteMuster = sv('rect', { 'class': 'rbsr-platte-muster', fill: 'url(#' + uid + '-diele)' }); gb.appendChild(this.platteMuster);
    this.mensch = sv('path', { 'class': 'rbsr-mensch',
      d: 'M-11 -162a11 11 0 1 0 22 0a11 11 0 1 0-22 0zM-20 -146q-3 0-3 4l-2 47q0 4 4 4h2l1 88q0 3 4 3h8q3 0 3-3l1-77h4l1 77q0 3 3 3h8q4 0 4-3l1-88h2q4 0 4-4l-2-47q0-4-3-4z' });
    gm.appendChild(this.mensch);
    this.matte = sv('rect', { 'class': 'rbsr-matte', fill: 'url(#' + uid + '-rohr)' }); gw.appendChild(this.matte);
    this.licht = sv('rect', { 'class': 'rbsr-matte-licht', fill: 'url(#' + uid + '-licht)' }); gw.appendChild(this.licht);
    this.draht = sv('path', { 'class': 'rbsr-draht' }); gw.appendChild(this.draht);
    this.naehte = sv('path', { 'class': 'rbsr-naht' }); gw.appendChild(this.naehte);
    this.rest = sv('rect', { 'class': 'rbsr-rest' }); gw.appendChild(this.rest);
    this.schnitt = sv('path', { 'class': 'rbsr-schnitt' }); gw.appendChild(this.schnitt);
    this.fuellung = sv('rect', { 'class': 'rbsr-stuetze-fuellung' }); gs.appendChild(this.fuellung);
    this.stuetze = sv('path', { 'class': 'rbsr-stuetze' }); gs.appendChild(this.stuetze);
    this.massL = sv('path', { 'class': 'rbsr-mass' }); gx.appendChild(this.massL);
    this.massLText = sv('text', { 'class': 'rbsr-mass-text', 'text-anchor': 'middle' }); gx.appendChild(this.massLText);
    this.massH = sv('path', { 'class': 'rbsr-mass' }); gx.appendChild(this.massH);
    this.massHText = sv('text', { 'class': 'rbsr-mass-text', 'text-anchor': 'start', 'dominant-baseline': 'middle' }); gx.appendChild(this.massHText);
    this.teilStriche = sv('path', { 'class': 'rbsr-mass rbsr-mass--fein' }); gx.appendChild(this.teilStriche);
    this.teilTexte = [];
    for (var i = 0; i < 10; i++) {
      var t = sv('text', { 'class': 'rbsr-teil-text', 'text-anchor': 'middle' });
      gx.appendChild(t); this.teilTexte.push(t);
    }
    this.schnittText = sv('text', { 'class': 'rbsr-teil-text', 'text-anchor': 'middle' }); gx.appendChild(this.schnittText);
    this.box.appendChild(svg);

    this.W = 700; this.H = 320; this.wert = null; this.ziel = null; this.raf = 0;
    var self = this;
    if (global.ResizeObserver) {
      new ResizeObserver(function (eintraege) {
        var w = Math.round(eintraege[0].contentRect.width);
        if (w > 0 && Math.abs(w - self.W) > 1) { self.W = w; self.groesse(); }
      }).observe(this.box);
    }
    this.groesse();
  }
  Szene.prototype.groesse = function () {
    /* 05.10.2026 (Faruk: Varianten und Regler moeglichst auf EINEM Bildschirm): Szene flacher — breit 210–270 px,
       schmal 170–210 px (vorher bis 420 px). Die Zeichnung skaliert ueber min(sV, sH) mit. */
    this.H = Math.round(this.W >= 600 ? Math.min(270, Math.max(210, this.W * 0.3)) : Math.min(210, Math.max(170, this.W * 0.55)));
    setze(this.svg, 'viewBox', '0 0 ' + this.W + ' ' + this.H);
    setze(this.svg, 'width', this.W); setze(this.svg, 'height', this.H);
    if (this.wert) this.zeichne(this.wert);
  };
  Szene.prototype.farbe = function (ton, steg) {
    var s = this.svg.style;
    s.setProperty('--rbsr-rohr', ton[0]); s.setProperty('--rbsr-rohr-licht', ton[1]); s.setProperty('--rbsr-rohr-schatten', ton[2]);
    setze(this.steg, 'opacity', steg ? '0.55' : '0');
    this.svg.classList.toggle('is-steg', !!steg);
  };
  /* Ziel setzen; unterbrechbar: die Bewegung startet immer vom aktuell gezeichneten Zustand */
  Szene.prototype.zu = function (ziel) {
    var self = this;
    if (!this.wert || (reduziert && reduziert.matches)) {
      this.wert = ziel; this.ziel = ziel;
      if (this.raf) { cancelAnimationFrame(this.raf); this.raf = 0; }
      this.zeichne(ziel); return;
    }
    this.von = this.wert; this.ziel = ziel; this.t0 = performance.now();
    if (!this.raf) this.raf = requestAnimationFrame(function schritt(jetzt) {
      var p = Math.min(1, (jetzt - self.t0) / 260), e = EASE(p), v = {};
      for (var k in self.ziel) {
        var a = self.von[k], b = self.ziel[k];
        v[k] = typeof a === 'number' && typeof b === 'number' ? a + (b - a) * e : b;
      }
      self.wert = v; self.zeichne(v);
      self.raf = p < 1 ? requestAnimationFrame(schritt) : 0;
    });
  };
  function rechteck(x, y, w, h) { return 'M' + r1(x) + ' ' + r1(y) + 'h' + r1(w) + 'v' + r1(h) + 'h' + r1(-w) + 'z'; }
  function r1(n) { return Math.round(n * 10) / 10; }
  /* Ein Bild aus Zahlen: lm (Matte, m), ls (Fläche, m), hm (Matte, cm), hs (Geländer, cm) */
  Szene.prototype.zeichne = function (v) {
    var W = this.W, H = this.H, oben = 26, unten = 64, rechts = 96;   // 96 statt 68: "100 cm" neben der Maßlinie wurde rechts abgeschnitten (04.10.2026)
    var gy = H - unten;
    var lMax = Math.max(v.lm, v.ls) * 100;
    var sV = (gy - oben) / (Math.max(v.hm, v.hs, 180) + 8);
    var sH = (W - 12 - rechts) / (lMax + 75);
    var s = Math.min(sV, sH);
    var x0 = 12 + 75 * s;
    var lmPx = v.lm * 100 * s, lsPx = v.ls * 100 * s, hmPx = v.hm * s, hsPx = v.hs * s;
    var xEnde = x0 + Math.max(lmPx, lsPx);

    /* Mensch zum Größenvergleich, 1,75 m */
    setze(this.mensch, 'transform', 'translate(' + r1(x0 - 42 * s) + ' ' + gy + ') scale(' + (Math.round(s * 1000) / 1000) + ')');

    /* Boden je Montageort */
    setze(this.boden, 'd', 'M0 ' + gy + 'H' + W);
    var ort = v.ort;
    var platteH = ort === 'balkon' ? Math.max(8, 18 * s) : (ort === 'terrasse' ? Math.max(6, 10 * s) : 0);
    setze(this.platte, 'x', r1(x0 - 20)); setze(this.platte, 'y', gy);
    setze(this.platte, 'width', r1(Math.max(0, lsPx + 40))); setze(this.platte, 'height', r1(platteH));
    setze(this.platteMuster, 'x', r1(x0 - 20)); setze(this.platteMuster, 'y', gy);
    setze(this.platteMuster, 'width', r1(ort === 'terrasse' ? Math.max(0, lsPx + 40) : 0)); setze(this.platteMuster, 'height', r1(platteH));
    setze(this.diele, 'width', r1(Math.max(10, 14 * s)));

    /* Matte */
    var my = gy - hmPx;
    [this.matte, this.licht].forEach(function (r) {
      setze(r, 'x', r1(x0)); setze(r, 'y', r1(my)); setze(r, 'width', r1(lmPx)); setze(r, 'height', r1(hmPx));
    });
    var d = '';
    [0.18, 0.5, 0.82].forEach(function (f) { d += 'M' + r1(x0) + ' ' + r1(my + hmPx * f) + 'h' + r1(lmPx); });
    setze(this.draht, 'd', d);

    /* Nähte zwischen den einzelnen Matten + Teil-Beschriftung */
    var teile = v.teile || [], summe = 0, i;
    teile.forEach(function (t) { summe += t; });
    var nd = '', striche = '', pos = 0, ty = gy + 20;
    for (i = 0; i < this.teilTexte.length; i++) {
      var tt = this.teilTexte[i];
      if (i < teile.length && teile.length > 1 && summe > 0) {
        var xa = x0 + (pos / summe) * lmPx, xb = x0 + ((pos + teile[i]) / summe) * lmPx;
        if (i > 0) nd += 'M' + r1(xa) + ' ' + r1(my) + 'V' + gy;
        striche += 'M' + r1(xa) + ' ' + (ty - 12) + 'v8M' + r1(xb) + ' ' + (ty - 12) + 'v8';
        setze(tt, 'x', r1((xa + xb) / 2)); setze(tt, 'y', ty + 2);
        text(tt, xb - xa > 26 ? R.formatMeter(teile[i]) : '');
        setze(tt, 'opacity', xb - xa > 26 ? 1 : 0);
        pos += teile[i];
      } else { text(tt, ''); setze(tt, 'opacity', 0); }
    }
    setze(this.naehte, 'd', nd);
    setze(this.teilStriche, 'd', striche);

    /* Überlänge zum Kürzen */
    var rest = lmPx - lsPx;
    if (rest > 0.5) {
      setze(this.rest, 'x', r1(x0 + lsPx)); setze(this.rest, 'y', r1(my)); setze(this.rest, 'width', r1(rest)); setze(this.rest, 'height', r1(hmPx));
      setze(this.schnitt, 'd', 'M' + r1(x0 + lsPx) + ' ' + r1(my - 8) + 'V' + gy);
      setze(this.schnittText, 'x', r1(x0 + lsPx)); setze(this.schnittText, 'y', r1(my - 12));
      text(this.schnittText, v.schnittText || ''); setze(this.schnittText, 'opacity', 1);
    } else {
      setze(this.rest, 'width', 0); setze(this.schnitt, 'd', ''); text(this.schnittText, ''); setze(this.schnittText, 'opacity', 0);
    }

    /* Geländer bzw. Zaun — vor der Matte, die Matte hängt dahinter */
    var top = gy - hsPx, p = '', abstand, n, k, x;
    if (ort === 'zaun') {
      abstand = 250; n = Math.max(1, Math.ceil(v.ls * 100 / abstand));
      for (k = 0; k <= n; k++) { x = x0 + (k / n) * lsPx; p += rechteck(x - 2.5, top - 6, 5, hsPx + 6); }
      setze(this.fuellung, 'fill', 'url(#' + this.uid + '-masche)');
      setze(this.masche, 'width', r1(Math.max(5, 5 * s))); setze(this.masche, 'height', r1(Math.max(12, 20 * s)));
      setze(this.mascheH, 'width', r1(Math.max(5, 5 * s)));
      setze(this.mascheV, 'height', r1(Math.max(12, 20 * s)));
      setze(this.mascheV, 'height', r1(Math.max(12, 20 * s)));
      setze(this.fuellung, 'x', r1(x0)); setze(this.fuellung, 'y', r1(top)); setze(this.fuellung, 'width', r1(lsPx)); setze(this.fuellung, 'height', r1(hsPx));
    } else if (ort === 'terrasse') {
      abstand = 180; n = Math.max(1, Math.ceil(v.ls * 100 / abstand));
      for (k = 0; k <= n; k++) { x = x0 + (k / n) * lsPx; p += rechteck(x - 4, top, 8, hsPx); }
      p += rechteck(x0 - 6, top - 4, lsPx + 12, 8);
      setze(this.fuellung, 'width', 0);
    } else {
      abstand = 150; n = Math.max(1, Math.ceil(v.ls * 100 / abstand));
      for (k = 0; k <= n; k++) { x = x0 + (k / n) * lsPx; p += rechteck(x - 2, top, 4, hsPx); }
      p += rechteck(x0 - 4, top - 3, lsPx + 8, 6);
      p += rechteck(x0, gy - 10 * s - 2, lsPx, 3);
      setze(this.fuellung, 'fill', 'url(#' + this.uid + '-stab)');
      setze(this.stab, 'width', r1(Math.max(6, 12 * s)));
      setze(this.fuellung, 'x', r1(x0)); setze(this.fuellung, 'y', r1(top)); setze(this.fuellung, 'width', r1(lsPx)); setze(this.fuellung, 'height', r1(Math.max(0, hsPx - 10 * s)));
    }
    setze(this.stuetze, 'd', p);

    /* Maßlinien */
    var ly = gy + 46;
    setze(this.massL, 'd', 'M' + r1(x0) + ' ' + (ly - 5) + 'v10M' + r1(x0) + ' ' + ly + 'H' + r1(x0 + lmPx) + 'M' + r1(x0 + lmPx) + ' ' + (ly - 5) + 'v10');
    setze(this.massLText, 'x', r1(x0 + lmPx / 2)); setze(this.massLText, 'y', ly - 6);
    text(this.massLText, v.lText || '');
    var hx = xEnde + 14;
    setze(this.massH, 'd', 'M' + r1(hx - 5) + ' ' + gy + 'h10M' + r1(hx) + ' ' + gy + 'V' + r1(my) + 'M' + r1(hx - 5) + ' ' + r1(my) + 'h10');
    setze(this.massHText, 'x', r1(hx + 8)); setze(this.massHText, 'y', r1(my + hmPx / 2));
    text(this.massHText, v.hText || '');
  };

  /* ---------- Rechner ---------- */
  function Rechner(wurzel) {
    this.w = wurzel;
    var json = function (sel) {
      var n = wurzel.querySelector(sel);
      try { return n ? JSON.parse(n.textContent) : null; } catch (e) { return null; }
    };
    var cfg = this.cfg = json('[data-rbsr-config]') || {};
    this.produkte = R.normalisiere(json('[data-rbsr-daten]') || {});
    this.T = {};
    var k;
    for (k in TEXTE) this.T[k] = TEXTE[k];
    for (k in (cfg.texte || {})) if (cfg.texte[k]) this.T[k] = cfg.texte[k];
    this.kompakt = cfg.modus === 'kompakt';
    this.maxU = cfg.maxUeberstand === undefined ? 10 : +cfg.maxUeberstand;
    this.uid = wurzel.id || ('rbsr-' + Math.random().toString(36).slice(2, 8));

    var matten = this.produkte.filter(function (p) { return p.familie === 'matte'; });
    if (!matten.length) return;
    var farbenReihe = [], typenReihe = [];
    matten.forEach(function (p) {
      if (farbenReihe.indexOf(p.farbe) < 0) farbenReihe.push(p.farbe);
      if (typenReihe.indexOf(p.typ) < 0) typenReihe.push(p.typ);
    });
    this.farben = farbenReihe; this.typen = typenReihe;
    var start = cfg.start || {}, vor = cfg.vorwahl || {};
    this.st = {
      laenge: R.begrenzen(+start.laenge || 5, 1, 30, 0.5),
      stuetze: R.begrenzen(+start.hoehe || 100, 60, 200, 1),
      farbe: farbenReihe.indexOf(vor.farbe) >= 0 ? vor.farbe : (farbenReihe.indexOf(start.farbe) >= 0 ? start.farbe : farbenReihe[0]),
      typ: typenReihe.indexOf(vor.typ) >= 0 ? vor.typ : (typenReihe.indexOf('ohne') >= 0 ? 'ohne' : typenReihe[0]),
      ort: 'balkon', leiste: false, ueberstandOk: false, alternative: null
    };
    this.gestartet = false; this.letztesSignal = '';
    this.bauen();
    wurzel.setAttribute('data-bereit', '');
    this.render(true);
  }

  Rechner.prototype.farbName = function (f) { return this.T.farben[f] || (f.charAt(0).toUpperCase() + f.slice(1)); };
  Rechner.prototype.typTitel = function (t) { return this.T['typ_' + t + '_titel'] || t; };

  Rechner.prototype.bauen = function () {
    var self = this, T = this.T, uid = this.uid, app = this.w.querySelector('[data-rbsr-app]');
    if (!app) return;
    app.textContent = '';
    var links = el('div', { 'class': 'rbsr__links' });
    var rechts = el('div', { 'class': 'rbsr__rechts' });
    var grid = el('div', { 'class': 'rbsr__grid' }, [links, rechts]);
    app.appendChild(grid);

    /* Bühne mit Szene */
    if (!this.kompakt) {
      var buehne = el('div', { 'class': 'rbsr__karte rbsr__buehne' });
      var ortFs = el('fieldset', { 'class': 'rbsr__segment' });
      ortFs.appendChild(el('legend', { 'class': 'rbsr__vh', text: T.ort }));
      this.segmentMarke = el('span', { 'class': 'rbsr__segment-marke', 'aria-hidden': 'true' });
      ortFs.appendChild(this.segmentMarke);
      ['balkon', 'zaun', 'terrasse'].forEach(function (o, i) {
        var inp = el('input', { type: 'radio', name: uid + '-ort', value: o, 'class': 'rbsr__vh', checked: o === self.st.ort });
        inp.addEventListener('change', function () { self.setze({ ort: o }); });
        ortFs.appendChild(el('label', { 'class': 'rbsr__segment-feld' }, [inp, el('span', { text: T.orte[o] })]));
      });
      /* 05.10.2026 (Faruk): Farbe sitzt rechts neben Balkon/Zaun/Terrasse in einer Zeile — der Eingabeblock darunter
         wird kuerzer, Regler und Ausfuehrung stehen mit der Szene auf einem Bildschirm. */
      var leiste = this.buehnenLeiste = el('div', { 'class': 'rbsr__leiste' }, [ortFs]);
      buehne.appendChild(leiste);
      this.szene = new Szene(buehne, uid);
      buehne.appendChild(this.szene.box);
      this.bildzeile = el('p', { 'class': 'rbsr__bildzeile', id: uid + '-bild' });
      buehne.appendChild(this.bildzeile);
      this.szene.svg.setAttribute('aria-labelledby', uid + '-bild');
      links.appendChild(buehne);
    }

    /* Eingaben */
    var eing = el('div', { 'class': 'rbsr__karte rbsr__eingaben' });
    this.laengeFeld = this.reglerFeld('laenge', T.laenge, T.laengeHilfe, 1, 30, 0.5, 'm', T.laengeFehler);
    this.hoeheFeld = this.reglerFeld('stuetze', T.hoehe, T.hoeheHilfe, 60, 200, 1, 'cm', T.hoeheFehler);
    eing.appendChild(this.laengeFeld.box);
    eing.appendChild(this.hoeheFeld.box);

    var farbFs = el('fieldset', { 'class': 'rbsr__gruppe' });
    farbFs.appendChild(el('legend', { 'class': 'rbsr__label', text: T.farbe }));
    var farbReihe = el('div', { 'class': 'rbsr__farben' });
    this.farbInputs = {};
    this.farben.forEach(function (f) {
      var p = R.finde(self.produkte, 'matte', f, self.typen[0]) || R.finde(self.produkte, 'matte', f);
      var ton = farbTon(f, p);
      var inp = el('input', { type: 'radio', name: uid + '-farbe', value: f, 'class': 'rbsr__vh', checked: f === self.st.farbe });
      inp.addEventListener('change', function () { self.setze({ farbe: f }); });
      self.farbInputs[f] = inp;
      var muster = el('span', { 'class': 'rbsr__muster', 'aria-hidden': 'true' });
      muster.style.setProperty('--m1', ton[0]); muster.style.setProperty('--m2', ton[1]); muster.style.setProperty('--m3', ton[2]);
      // Produktfoto im Farbfeld (11.10.2026, aus ribelli.fr übernommen): das Bild des gewählten Artikels statt nur der Farbfläche
      if (p && p.bild) { muster.classList.add('rbsr__muster--bild'); muster.style.setProperty('--bild', 'url("' + p.bild + (p.bild.indexOf('?') > -1 ? '&' : '?') + 'width=160")'); }
      farbReihe.appendChild(el('label', { 'class': 'rbsr__farbe' }, [inp, muster, el('span', { 'class': 'rbsr__farbe-name', text: self.farbName(f) })]));
    });
    farbFs.appendChild(farbReihe);
    if (this.buehnenLeiste) {
      farbFs.classList.add('rbsr__gruppe--leiste');
      this.buehnenLeiste.appendChild(farbFs);
    } else {
      eing.appendChild(farbFs);
    }

    var typFs = el('fieldset', { 'class': 'rbsr__gruppe' });
    typFs.appendChild(el('legend', { 'class': 'rbsr__label', text: T.ausfuehrung }));
    var typReihe = el('div', { 'class': 'rbsr__typen' });
    this.typKarten = {};
    this.typen.forEach(function (t) {
      var inp = el('input', { type: 'radio', name: uid + '-typ', value: t, 'class': 'rbsr__vh', checked: t === self.st.typ });
      inp.addEventListener('change', function () { self.setze({ typ: t }); });
      var preis = el('span', { 'class': 'rbsr__typ-preis' });
      var diff = el('span', { 'class': 'rbsr__typ-diff' });
      var innen = el('span', { 'class': 'rbsr__typ-innen' }, [
        el('span', { 'class': 'rbsr__typ-kopf' }, [el('span', { 'class': 'rbsr__typ-titel', text: self.typTitel(t) }), preis]),
        el('span', { 'class': 'rbsr__typ-text', text: T['typ_' + t + '_text'] || '' }),
        diff
      ]);
      self.typKarten[t] = { preis: preis, diff: diff, input: inp };
      typReihe.appendChild(el('label', { 'class': 'rbsr__typ' + (t === 'steg' ? ' rbsr__typ--steg' : '') }, [inp, innen]));
    });
    typFs.appendChild(typReihe);
    eing.appendChild(typFs);
    links.appendChild(eing);

    /* Ergebnis */
    var erg = this.ergebnis = el('section', { 'class': 'rbsr__karte rbsr__ergebnis', 'aria-labelledby': uid + '-et' });
    erg.appendChild(el('h2', { 'class': 'rbsr__e-titel', id: uid + '-et', text: T.ergebnisTitel }));
    this.eMasse = el('p', { 'class': 'rbsr__masse' });
    this.eProdukt = el('a', { 'class': 'rbsr__produkt' });
    this.eLive = el('p', { 'class': 'rbsr__vh', 'aria-live': 'polite', role: 'status' });
    this.eHoehe = el('div', { 'class': 'rbsr__hinweis' });
    this.eLieferung = el('p', { 'class': 'rbsr__lieferung' });
    this.eKuerzen = el('p', { 'class': 'rbsr__klein' });
    this.ePosten = el('ul', { 'class': 'rbsr__posten', role: 'list' });
    this.eStatus = el('p', { 'class': 'rbsr__status' });
    this.eAlt = el('div', { 'class': 'rbsr__alternativen' });
    erg.appendChild(this.eMasse); erg.appendChild(this.eProdukt); erg.appendChild(this.eLive);
    erg.appendChild(this.eHoehe); erg.appendChild(this.eLieferung); erg.appendChild(this.eKuerzen);
    erg.appendChild(this.ePosten); erg.appendChild(this.eStatus); erg.appendChild(this.eAlt);

    this.eLeiste = null;
    if (this.cfg.leisteAnbieten !== false && this.produkte.some(function (p) { return p.familie === 'leiste'; })) {
      this.leisteInput = el('input', { type: 'checkbox', 'class': 'rbsr__check' });
      this.leisteInput.checked = false; // § 312a Abs. 3 BGB: kostenpflichtige Zusatzleistung nie vorausgewählt
      this.leisteInput.addEventListener('change', function () { self.setze({ leiste: self.leisteInput.checked }); });
      this.leisteText = el('span', { 'class': 'rbsr__zusatz-titel' });
      this.leisteKlein = el('span', { 'class': 'rbsr__zusatz-text' });
      this.eLeiste = el('label', { 'class': 'rbsr__zusatz' }, [this.leisteInput, el('span', {}, [this.leisteText, this.leisteKlein])]);
      this.eLeisteNicht = el('p', { 'class': 'rbsr__klein', text: T.leisteNicht, hidden: true });
      erg.appendChild(this.eLeiste); erg.appendChild(this.eLeisteNicht);
    }

    this.eSumme = el('strong', { 'class': 'rbsr__summe-wert' });
    erg.appendChild(el('div', { 'class': 'rbsr__summe' }, [el('span', { text: T.gesamt }), this.eSumme]));
    var versand = el('a', { href: this.cfg.versandUrl || '/policies/shipping-policy', text: T.versand });
    erg.appendChild(el('p', { 'class': 'rbsr__steuer' }, [T.steuer + ' ', versand]));
    this.kaufKnopf = el('button', { type: 'button', 'class': 'button button--primary rbsr__kaufen', 'aria-describedby': uid + '-grund' }, [el('span', { 'class': 'rbsr__kaufen-text', text: T.kaufen })]);
    if (document.querySelector('cart-drawer')) this.kaufKnopf.setAttribute('aria-haspopup', 'dialog');
    this.kaufKnopf.addEventListener('click', function () { self.inDenWarenkorb(self.kaufKnopf); });
    this.eGrund = el('p', { 'class': 'rbsr__grund', id: uid + '-grund' });
    this.eFehler = el('p', { 'class': 'rbsr__fehler', role: 'alert', hidden: true });
    this.eOk = el('p', { 'class': 'rbsr__ok', role: 'status' });
    this.eZumProdukt = el('a', { 'class': 'rbsr__link' }, [el('span', { text: T.zumProdukt }), icon('pfeil')]);
    erg.appendChild(this.kaufKnopf); erg.appendChild(this.eGrund); erg.appendChild(this.eFehler); erg.appendChild(this.eOk);
    var fuss = el('div', { 'class': 'rbsr__fuss' }, [this.eZumProdukt]);
    if (this.kompakt && this.cfg.rechnerUrl) {
      fuss.appendChild(el('a', { 'class': 'rbsr__link', href: this.cfg.rechnerUrl }, [el('span', { text: T.zumRechner }), icon('pfeil')]));
    }
    erg.appendChild(fuss);
    rechts.appendChild(erg);

    /* Mini-Leiste (Telefon): direkt an <body>, damit kein transformierter Vorfahre fixed bricht */
    if (!this.kompakt) {
      this.miniSumme = el('strong', { 'class': 'rbsr__mini-summe' });
      this.miniMasse = el('span', { 'class': 'rbsr__mini-masse' });
      this.miniKnopf = el('button', { type: 'button', 'class': 'button button--primary rbsr__mini-knopf' }, [el('span', { 'class': 'rbsr__kaufen-text', text: T.kaufen })]);
      this.miniKnopf.addEventListener('click', function () { self.inDenWarenkorb(self.miniKnopf); });
      var details = el('button', { type: 'button', 'class': 'rbsr__mini-details' }, [this.miniMasse, el('span', { 'class': 'rbsr__mini-link', text: T.zumErgebnis })]);
      details.addEventListener('click', function () {
        self.ergebnis.scrollIntoView({ behavior: reduziert && reduziert.matches ? 'auto' : 'smooth', block: 'start' });
        self.ergebnis.setAttribute('tabindex', '-1'); self.ergebnis.focus({ preventScroll: true });
      });
      this.mini = el('div', { 'class': 'rbsr__mini ' + (this.w.getAttribute('data-schema') || ''), 'aria-hidden': 'true' },
        [el('div', { 'class': 'rbsr__mini-info' }, [this.miniSumme, details]), this.miniKnopf]);
      this.mini.inert = true;
      document.body.appendChild(this.mini);
      this.w._rbsrMini = this.mini;
      this.beobachten();
    }

    /* Erste Interaktion für die Messung */
    var start = function () {
      if (self.gestartet) return;
      self.gestartet = true;
      self.signal('sichtschutz_rechner_start', { modus: self.kompakt ? 'kompakt' : 'voll' });
    };
    app.addEventListener('input', start, true);
    app.addEventListener('change', start, true);
    app.addEventListener('pointerdown', start, true);
  };

  /* Regler + Zahlenfeld, beide immer synchron */
  Rechner.prototype.reglerFeld = function (key, label, hilfe, min, max, schritt, einheit, fehlerText) {
    var self = this, uid = this.uid, id = uid + '-' + key;
    var regler = el('input', { type: 'range', id: id + '-r', min: min, max: max, step: schritt, 'class': 'rbsr__regler', 'aria-describedby': id + '-h' });
    var zahl = el('input', { type: 'text', id: id, inputmode: 'decimal', autocomplete: 'off', 'class': 'rbsr__zahl-feld',
      'aria-describedby': id + '-h ' + id + '-f', spellcheck: 'false' });
    var fehler = el('p', { 'class': 'rbsr__feld-fehler', id: id + '-f', hidden: true, text: fmt(fehlerText, { min: R.formatZahl(min, 0) + ' ' + einheit, max: R.formatZahl(max, 0) + ' ' + einheit }) });
    var box = el('div', { 'class': 'rbsr__feld' }, [
      el('div', { 'class': 'rbsr__feld-kopf' }, [
        el('label', { 'class': 'rbsr__label', 'for': id, text: label }),
        el('span', { 'class': 'rbsr__zahl' }, [zahl, el('span', { 'class': 'rbsr__einheit', 'aria-hidden': 'true', text: einheit })])
      ]),
      el('label', { 'class': 'rbsr__vh', 'for': id + '-r', text: label + ' (Regler)' }),
      regler,
      el('div', { 'class': 'rbsr__skala', 'aria-hidden': 'true' }, [el('span', { text: R.formatZahl(min, 0) + ' ' + einheit }), el('span', { text: R.formatZahl(max, 0) + ' ' + einheit })]),
      el('p', { 'class': 'rbsr__hilfe', id: id + '-h', text: hilfe }),
      fehler
    ]);
    var anzeigen = function (v) { return einheit === 'm' ? R.formatZahl(v, v % 1 ? 1 : 0) : String(Math.round(v)); };
    regler.addEventListener('input', function () {
      var p = {}; p[key] = +regler.value; self.setze(p);
    });
    zahl.addEventListener('input', function () {
      var v = R.zahlAus(zahl.value);
      var gut = isFinite(v) && v >= min && v <= max;
      fehler.hidden = gut || zahl.value.trim() === '';
      zahl.setAttribute('aria-invalid', gut ? 'false' : 'true');
      if (gut) { var p = {}; p[key] = R.begrenzen(v, min, max, key === 'laenge' ? 0.1 : 1); self.setze(p, true); }
    });
    var fertig = function () {
      var v = R.zahlAus(zahl.value);
      var p = {}; p[key] = R.begrenzen(isFinite(v) ? v : self.st[key], min, max, key === 'laenge' ? 0.1 : 1);
      fehler.hidden = true; zahl.setAttribute('aria-invalid', 'false');
      zahl.value = anzeigen(p[key]);
      self.setze(p);
    };
    zahl.addEventListener('change', fertig);
    zahl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); fertig(); }
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
        var p = {}; p[key] = R.begrenzen(self.st[key] + (e.key === 'ArrowUp' ? schritt : -schritt), min, max, schritt);
        zahl.value = anzeigen(p[key]); self.setze(p);
      }
    });
    return { box: box, regler: regler, zahl: zahl, min: min, max: max, anzeigen: anzeigen };
  };

  Rechner.prototype.setze = function (patch, vomFeld) {
    var alt = this.st, neu = {}, k;
    for (k in alt) neu[k] = alt[k];
    for (k in patch) neu[k] = patch[k];
    if (patch.laenge !== undefined || patch.stuetze !== undefined || patch.farbe !== undefined || patch.typ !== undefined) neu.alternative = null;
    if (patch.stuetze !== undefined && patch.stuetze !== alt.stuetze) neu.ueberstandOk = false;
    this.st = neu;
    this.vomFeld = !!vomFeld;
    this.eOk.textContent = '';
    this.planen();
  };
  Rechner.prototype.planen = function () {
    var self = this;
    if (this.geplant) return;
    this.geplant = true;
    requestAnimationFrame(function () { self.geplant = false; self.render(false); });
  };

  /* Erst rechnen, dann einmal schreiben */
  Rechner.prototype.render = function (erstes) {
    var self = this, T = this.T, st = this.st;
    var opts = { maxUeberstand: this.maxU, leiste: this.cfg.leisteAnbieten !== false };
    var res = this.res = R.berechne(st, this.produkte, opts);
    var proTyp = {};
    this.typen.forEach(function (t) {
      var e = {}; for (var k in st) e[k] = st[k]; e.typ = t; e.alternative = null;
      proTyp[t] = R.berechne(e, self.produkte, opts);
    });
    var mitLeiste = st.leiste && res.leiste && res.leiste.kombi;
    var summe = R.summe(res, mitLeiste);
    var hoehe = res.hoehe ? res.hoehe.hoehe : 0;
    var aktiv = res.aktiv, prod = aktiv ? aktiv.produkt : res.produkt;
    var kombi = aktiv ? aktiv.kombi : res.wunsch;
    var stuetzeName = T.stuetzeName[st.ort] || T.stuetzeName.balkon;

    /* Eingaben */
    [[this.laengeFeld, st.laenge], [this.hoeheFeld, st.stuetze]].forEach(function (f) {
      var feld = f[0], v = f[1];
      if (document.activeElement !== feld.regler) feld.regler.value = v;
      feld.regler.style.setProperty('--pct', ((v - feld.min) / (feld.max - feld.min) * 100).toFixed(2) + '%');
      if (document.activeElement !== feld.zahl || !self.vomFeld) {
        if (document.activeElement !== feld.zahl) feld.zahl.value = feld.anzeigen(v);
      }
      feld.regler.setAttribute('aria-valuetext', feld.anzeigen(v) + (feld === self.laengeFeld ? ' Meter' : ' Zentimeter'));
    });
    this.typen.forEach(function (t) {
      var k = self.typKarten[t], r = proTyp[t];
      var preis = r.wunsch ? r.wunsch.preis : null;
      text(k.preis, preis !== null ? R.formatEuro(preis) : '–');
      var basis = proTyp.ohne && proTyp.ohne.wunsch ? proTyp.ohne.wunsch.preis : null;
      var d = '';
      if (t !== 'ohne' && basis !== null && preis !== null) {
        d = preis > basis ? fmt(T.preisDiff, { x: R.formatEuro(preis - basis) }) : (preis < basis ? fmt(T.preisWeniger, { x: R.formatEuro(basis - preis) }) : T.preisGleich);
      }
      if (r.wunsch && !r.lieferbar) d = T.nichtLieferbarKurz;
      text(k.diff, d);
      k.diff.hidden = !d;
      k.input.checked = t === st.typ;
    });
    for (var f in this.farbInputs) this.farbInputs[f].checked = f === st.farbe;

    if (res.fehler) {
      text(this.eMasse, '–'); text(this.eSumme, '–');
      this.eHoehe.hidden = true; this.eLieferung.textContent = ''; this.ePosten.textContent = '';
      this.knopfStatus(T.grundKeine);
      return;
    }

    /* Szene */
    var ton = farbTon(st.farbe, prod);
    if (this.szene) {
      this.szene.farbe(ton, (prod && prod.typ) === 'steg');
      var lm = kombi ? kombi.summe : res.ziel;
      this.szene.zu({
        lm: lm, ls: st.laenge, hm: hoehe, hs: st.stuetze, ort: st.ort, teile: res.matten,
        lText: R.formatMeter(lm), hText: R.formatCm(hoehe),
        schnittText: R.formatMeter(st.laenge)
      });
      var ortIndex = ['balkon', 'zaun', 'terrasse'].indexOf(st.ort);
      this.segmentMarke.style.transform = 'translateX(' + (ortIndex * 100) + '%)';
      text(this.bildzeile, fmt(T.szene, { l: R.formatMeter(lm), h: R.formatCm(hoehe), stuetze: stuetzeName, s: R.formatCm(st.stuetze) }));
    }

    /* Ergebnis */
    text(this.eMasse, fmt(T.kurz, { l: R.formatMeter(kombi.summe), h: R.formatCm(hoehe) }));
    text(this.eProdukt, prod.title);
    setze(this.eProdukt, 'href', prod.url);
    setze(this.eZumProdukt, 'href', prod.url);

    var hw = res.hoehe, ht = '', ton2 = 'info';
    var w = { h: R.formatCm(hw.hoehe), u: R.formatCm(Math.abs(hw.ueberstand)), s: R.formatCm(st.stuetze), max: R.formatCm(this.maxU), stuetze: stuetzeName };
    if (hw.status === 'zu_niedrig') { ht = fmt(T.hoeheZuNiedrig, w); ton2 = 'warn'; }
    else if (hw.status === 'zu_hoch') { ht = fmt(T.hoeheZuHoch, w); ton2 = 'warn'; }
    else if (hw.ueberstand > 0) ht = fmt(T.hoeheOk, w);
    else if (hw.ueberstand === 0) ht = fmt(T.hoeheBuendig, w);
    else ht = fmt(T.hoeheUnter, w);
    var sig = ht + '|' + ton2 + '|' + st.ueberstandOk;
    if (this.eHoehe._sig !== sig) {
      this.eHoehe._sig = sig;
      this.eHoehe.textContent = '';
      this.eHoehe.setAttribute('data-ton', ton2);
      this.eHoehe.appendChild(icon(ton2 === 'warn' ? 'warn' : 'info'));
      var inner = el('div', {}, [el('p', { text: ht })]);
      if (hw.status === 'zu_niedrig') {
        var trotz = el('button', { type: 'button', 'class': 'rbsr__textknopf', 'aria-pressed': st.ueberstandOk ? 'true' : 'false', text: fmt(T.hoeheTrotzdem, w) });
        trotz.addEventListener('click', function () { self.setze({ ueberstandOk: !self.st.ueberstandOk }); });
        inner.appendChild(trotz);
      }
      this.eHoehe.appendChild(inner);
    }
    this.eHoehe.hidden = false;

    text(this.eLieferung, res.matten.length > 1 ? fmt(T.lieferungN, { n: res.matten.length, teile: R.teileText(res.matten) }) : T.lieferung1);
    var kSig = res.ueberlaenge > 0.05 ? R.formatMeter(res.ueberlaenge) + prod.url : '';
    if (this.eKuerzen._sig !== kSig) {
      this.eKuerzen._sig = kSig;
      this.eKuerzen.textContent = '';
      if (kSig) {
        this.eKuerzen.appendChild(icon('schere'));
        this.eKuerzen.appendChild(el('span', {}, [fmt(T.kuerzen, { x: R.formatMeter(res.ueberlaenge) }) + ' ', el('a', { href: prod.url, text: T.kuerzenLink })]));
      }
    }
    this.eKuerzen.hidden = !kSig;

    /* Positionen */
    var posten = R.positionen(kombi);
    var pSig = JSON.stringify(posten) + hoehe;
    if (this.ePosten._sig !== pSig) {
      this.ePosten._sig = pSig;
      this.ePosten.textContent = '';
      posten.forEach(function (p) {
        var links = el('span', { 'class': 'rbsr__posten-name', text: fmt(T.stueckPos, { n: p.anzahl, l: R.formatMeter(p.laenge), h: R.formatCm(hoehe) }) });
        if (p.anzahl > 1) links.appendChild(el('small', { text: fmt(T.je, { x: R.formatEuro(p.preis) }) }));
        self.ePosten.appendChild(el('li', { 'class': p.lieferbar ? '' : 'is-weg' }, [links, el('span', { 'class': 'rbsr__posten-preis', text: R.formatEuro(p.preis * p.anzahl) })]));
      });
    }

    /* Verfügbarkeit + Alternativen */
    this.eStatus.textContent = '';
    if (res.lieferbar) {
      this.eStatus.setAttribute('data-ton', 'ok');
      this.eStatus.appendChild(el('span', { 'class': 'rbsr__punkt', 'aria-hidden': 'true' }));
      this.eStatus.appendChild(el('span', { text: T.lieferbar }));
    } else {
      this.eStatus.setAttribute('data-ton', 'weg');
      var weg = res.wunsch.teile.filter(function (t) { return !t.lieferbar; })[0];
      this.eStatus.appendChild(el('span', { 'class': 'rbsr__punkt', 'aria-hidden': 'true' }));
      this.eStatus.appendChild(el('span', {}, [fmt(T.nichtLieferbarText, { groesse: R.formatMeter(weg.laenge) + ' × ' + R.formatCm(hoehe) }) + ' ',
        el('a', { href: res.produkt.url + (res.produkt.url.indexOf('?') < 0 ? '?' : '&') + 'variant=' + weg.id, text: T.bisLink })]));
    }
    var aSig = res.lieferbar ? '' : JSON.stringify(res.alternativen.map(function (a) { return [a.art, a.produkt.handle, a.kombi.preis, a.kombi.summe]; })) + '|' + st.alternative;
    if (this.eAlt._sig !== aSig) {
      this.eAlt._sig = aSig;
      this.eAlt.textContent = '';
      if (!res.lieferbar && res.alternativen.length) {
        this.eAlt.appendChild(el('p', { 'class': 'rbsr__alt-titel', text: T.alternativenTitel }));
        res.alternativen.forEach(function (a, i) {
          var titel = a.art === 'aufteilung' ? fmt(T.alt_aufteilung, { teile: R.teileText(a.kombi.teile.map(function (t) { return t.laenge; })) })
            : a.art === 'laenger' ? fmt(T.alt_laenger, { x: R.formatMeter(a.kombi.summe) })
            : fmt(T.alt_typ, { typ: self.typTitel(a.produkt.typ), x: R.formatMeter(a.kombi.summe) + ' × ' + R.formatCm(a.hoehe) });
          var gewaehlt = st.alternative === i;
          var b = el('button', { type: 'button', 'class': 'rbsr__alt', 'aria-pressed': a.art === 'typ' ? null : (gewaehlt ? 'true' : 'false') }, [
            el('span', { text: titel }), el('span', { 'class': 'rbsr__alt-preis', text: R.formatEuro(a.kombi.preis) })]);
          b.addEventListener('click', function () {
            if (a.art === 'typ') self.setze({ typ: a.produkt.typ });
            else self.setze({ alternative: gewaehlt ? null : i });
          });
          self.eAlt.appendChild(b);
        });
      }
    }
    this.eAlt.hidden = res.lieferbar || !res.alternativen.length;

    /* Abschlussleiste */
    if (this.eLeiste) {
      var L = res.leiste;
      var hatLeiste = !!(L && L.kombi);
      this.eLeiste.hidden = !hatLeiste;
      this.eLeisteNicht.hidden = !(L && !L.kombi);
      if (hatLeiste) {
        text(this.leisteText, fmt(T.leiste, { n: L.kombi.summe, farbe: this.farbName(st.farbe) }) + ', + ' + R.formatEuro(L.kombi.preis));
        var lt = T.leisteText;
        if (L.kombi.stueck > 1) lt += ' ' + fmt(T.leisteAufteilung, { teile: L.kombi.teile.map(function (t) { return t.laenge; }).join(' + ') });
        text(this.leisteKlein, lt);
        this.leisteInput.checked = !!st.leiste;
      }
    }

    text(this.eSumme, aktiv ? R.formatEuro(summe) : '–');

    /* Knopf */
    if (res.gesperrt) this.knopfStatus(T.grundGesperrt);
    else if (!aktiv) this.knopfStatus(res.alternativen.length ? T.grundAlternative : T.grundKeine);
    else this.knopfStatus('');

    /* Mini-Leiste */
    if (this.mini) {
      text(this.miniSumme, aktiv ? R.formatEuro(summe) : '–');
      text(this.miniMasse, fmt(T.kurz, { l: R.formatMeter(kombi.summe), h: R.formatCm(hoehe) }));
    }

    /* Ansage für Screenreader, erst wenn die Eingabe ruht */
    clearTimeout(this.ansageTimer);
    var ansage = fmt(T.kurz, { l: R.formatMeter(kombi.summe), h: R.formatCm(hoehe) }) + ', ' +
      (res.matten.length > 1 ? res.matten.length + ' Matten' : '1 Matte') + ', ' + T.gesamt + ' ' + (aktiv ? R.formatEuro(summe) : '–') +
      (res.lieferbar ? '' : '. ' + T.nichtLieferbar);
    if (!erstes) this.ansageTimer = setTimeout(function () { text(self.eLive, ansage); }, 700);

    /* Messung (entprellt) */
    clearTimeout(this.signalTimer);
    if (!erstes) this.signalTimer = setTimeout(function () {
      var d = { laenge_m: kombi.summe, eingabe_m: st.laenge, stuetze_cm: st.stuetze, hoehe_cm: hoehe, typ: prod.typ, farbe: st.farbe,
                mit_leiste: !!mitLeiste, lieferbar: !!res.lieferbar, summe_eur: Math.round(summe) / 100, waehrung: 'EUR' };
      var s = JSON.stringify(d);
      if (s !== self.letztesSignal) { self.letztesSignal = s; self.signal('sichtschutz_rechner_ergebnis', d); }
    }, 1200);
  };

  Rechner.prototype.knopfStatus = function (grund) {
    var aus = !!grund || this.laedt;
    [this.kaufKnopf, this.miniKnopf].forEach(function (b) {
      if (!b) return;
      if (aus) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    text(this.eGrund, grund || '');
    this.eGrund.hidden = !grund;
  };

  Rechner.prototype.signal = function (ev, daten) {
    if (!Array.isArray(global.dataLayer)) return;
    var o = { event: ev };
    for (var k in daten || {}) o[k] = daten[k];
    global.dataLayer.push(o);
  };

  /* Mini-Leiste nur zeigen, solange der Rechner im Bild ist und die Ergebniskarte nicht */
  Rechner.prototype.beobachten = function () {
    var self = this;
    if (!global.IntersectionObserver) return;
    var appSicht = false, ergSicht = true;
    var stell = function () {
      var an = appSicht && !ergSicht;
      self.mini.classList.toggle('is-sichtbar', an);
      self.mini.setAttribute('aria-hidden', an ? 'false' : 'true');
      self.mini.inert = !an;
      document.documentElement.classList.toggle('rbsr-mini-offen', an);
    };
    new IntersectionObserver(function (e) { appSicht = e[0].isIntersecting; stell(); }, { rootMargin: '0px 0px -30% 0px' }).observe(this.w.querySelector('[data-rbsr-app]'));
    new IntersectionObserver(function (e) { ergSicht = e[0].isIntersecting; stell(); }, { threshold: 0.15 }).observe(this.ergebnis);
  };

  Rechner.prototype.inDenWarenkorb = function (knopf) {
    var self = this, T = this.T;
    if (knopf.getAttribute('aria-disabled') === 'true') {
      if (this.eGrund.textContent) { this.eGrund.classList.remove('is-betont'); void this.eGrund.offsetWidth; this.eGrund.classList.add('is-betont'); }
      return;
    }
    var res = this.res, mitLeiste = this.st.leiste && res.leiste && res.leiste.kombi;
    var items = R.warenkorbPosten(res, mitLeiste, 'sichtschutz-rechner');
    if (!items.length) return;
    this.eFehler.hidden = true; this.eOk.textContent = '';
    this.laedt = true;
    var knoepfe = [this.kaufKnopf, this.miniKnopf].filter(Boolean);
    knoepfe.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.setAttribute('aria-busy', 'true'); b.classList.add('is-laedt'); text(b.querySelector('.rbsr__kaufen-text'), T.laedt); });

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = global.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(knopf);
    }
    var url = ((global.routes && global.routes.cart_add_url) || '/cart/add') + '.js';
    var ende = function () {
      self.laedt = false;
      knoepfe.forEach(function (b) { b.removeAttribute('aria-busy'); b.classList.remove('is-laedt'); text(b.querySelector('.rbsr__kaufen-text'), T.kaufen); });
      self.render(true);
    };
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (antwort) {
      ende();
      if (antwort.status) {
        self.eFehler.textContent = antwort.description || antwort.message || T.fehlerNetz;
        self.eFehler.hidden = false;
        return;
      }
      self.signal('sichtschutz_rechner_warenkorb', {
        laenge_m: res.aktiv.kombi.summe, hoehe_cm: res.aktiv.hoehe, typ: res.aktiv.produkt.typ, farbe: self.st.farbe,
        mit_leiste: !!mitLeiste, positionen: items.length, summe_eur: Math.round(R.summe(res, mitLeiste)) / 100, waehrung: 'EUR'
      });
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sichtschutz-rechner', cartData: antwort }); } catch (e) { /* weiter */ }
      }
      if (cart && typeof cart.renderContents === 'function' && antwort.sections) {
        var erstes = (antwort.items && antwort.items[0]) || {};
        var zustand = {}; for (var k in antwort) zustand[k] = antwort[k];
        zustand.id = erstes.id; zustand.key = erstes.key;
        cart.renderContents(zustand);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        text(self.eOk, T.hinzugefuegt);
      } else {
        global.location.href = (global.routes && global.routes.cart_url) || '/cart';
      }
    }).catch(function () {
      ende();
      self.eFehler.textContent = T.fehlerNetz;
      self.eFehler.hidden = false;
    });
  };

  function starten() {
    var wurzeln = document.querySelectorAll('[data-rbsr]:not([data-bereit])');
    for (var i = 0; i < wurzeln.length; i++) {
      try { new Rechner(wurzeln[i]); } catch (e) { if (global.console) console.error('Sichtschutz-Rechner', e); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten); else starten();
  /* Theme-Editor: Sektion entfernt bzw. neu geladen — die an <body> gehängte Mini-Leiste mitnehmen */
  document.addEventListener('shopify:section:unload', function (e) {
    var w = e.target && e.target.querySelectorAll ? e.target.querySelectorAll('[data-rbsr]') : [];
    for (var i = 0; i < w.length; i++) if (w[i]._rbsrMini) { w[i]._rbsrMini.remove(); document.documentElement.classList.remove('rbsr-mini-offen'); }
  });
  document.addEventListener('shopify:section:load', starten);
})(typeof window !== 'undefined' ? window : this);
